<template>
  <campaigns-factory
    name="Campaigns Overview"
    adlabel=""
  />
</template>

<script>
import CampaignsFactory from '../campaigns-factory/CampaignsFactory'
export default {
  name: 'campaigns-overview',
  components: {
    CampaignsFactory
  }
}
</script>
